import { defineStore } from 'pinia';

export type ModalId =
  | 'invitation'
  | 'media'
  | 'privacy'
  | 'sourcingSuccess'
  | 'sourcingSurvey'
  | 'sourcingThanks'
  | 'careerDetails'
  | 'voiceDetails'
  | 'cvUpload'
  | 'invitationCompanySharepool'
  | 'cguUpdate';

type Modal = {
  visible: boolean;
  props?: unknown;
};

type State = Record<ModalId, Modal>;

export const useModalStore = defineStore('modal', {
  state: (): State => ({
    media: {
      visible: false,
    },
    invitation: {
      visible: false,
    },
    privacy: {
      visible: false,
    },
    sourcingSuccess: {
      visible: false,
    },
    sourcingSurvey: {
      visible: false,
    },
    sourcingThanks: {
      visible: false,
    },
    careerDetails: {
      visible: false,
    },
    voiceDetails: {
      visible: false,
    },
    cvUpload: {
      visible: false,
    },
    invitationCompanySharepool: {
      visible: false,
    },
    cguUpdate: {
      visible: false,
    },
  }),
  getters: {
    getModalVisibility: (state) => (key: ModalId) => {
      return state[key].visible;
    },
    getModalProps: (state) => (key: ModalId) => {
      return state[key].props;
    },
  },
  actions: {
    toggle(key: ModalId, props?: unknown, modalState?: boolean) {
      const newState = modalState ?? !this[key].visible;

      this.$state[key].visible = newState;

      if (!newState) this.$state[key].props = undefined;
      else this.$state[key].props = props;

      return newState;
    },
  },
});
